// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"7bf55ab8","57":"9bb11c29","153":"cded5b54","284":"5bd4df6e","489":"5f3193cf","593":"da07a423","813":"de9bff28","870":"45cb9418"}[chunkId] + ".chunk.js";
};